import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import { useCallback, useState } from 'react';
import CustomEmailProviderService, {
  CustomEmailProviderVerifyIntegrationResult,
} from './CustomEmailProviderService';

const useVerifyCustomEmailProviderIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<CustomEmailProviderVerifyIntegrationResult>>(
      defaultInitialState,
    );

  const verifyCustomEmailProviderIntegration = useCallback(
    async (email: string) => {
      setState({
        error: null,
        status: AsyncStatus.pending,
        data: null,
        isLoading: true,
      });
      const resultPromise =
        CustomEmailProviderService.verifyCustomEmailProviderIntegration(email);
      resultPromise.then(
        (result) => {
          setState({
            error: null,
            status: AsyncStatus.resolved,
            data: result,
            isLoading: false,
          });
        },
        (error) => {
          setState({
            error: error,
            status: AsyncStatus.rejected,
            data: null,
            isLoading: false,
          });
        },
      );
    },
    [setState],
  );

  return {
    verifyCustomEmailProviderIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifyCustomEmailProviderIntegration;
